import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { CropSequestrationUpload } from "pages/admin/experiments/CropSequestrationUpload";
import { FieldSizes } from "pages/admin/experiments/FieldSizes";
import { FieldSplitting } from "pages/admin/experiments/FieldSplitting";
import { ShapeFiles } from "pages/admin/experiments/ShapeFiles";
import { Speech } from "pages/admin/experiments/Speech";
import { Templates } from "pages/admin/experiments/Templates";
import { TranslationBranching } from "pages/admin/experiments/TranslationBranching";

export const Experiments = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Text to speech",
      key: "speech",
      component: <Speech />,
    },
    {
      name: "Shape files",
      key: "shapefiles",
      component: <ShapeFiles />,
    },
    {
      name: "Field sizes",
      key: "fieldsizes",
      component: <FieldSizes />,
    },
    {
      name: "Field splitting",
      key: "fieldSplitting",
      component: <FieldSplitting />,
    },
    {
      name: "Crop templates",
      key: "templates",
      component: <Templates />,
    },
    {
      name: "Crop sequestration uploads",
      key: "sequestration",
      component: <CropSequestrationUpload />,
    },
    {
      name: "Translation branching",
      key: "translations",
      component: <TranslationBranching />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `soilplus/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/soilplus/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
